import {applySpec, constant, flow, makeGet} from '@yandex-delivery/utils'

import {Fetch} from '../fetch'
import {addSafeHeaders} from '../utils'

type Config = {
  getURI: () => string
  lang: string
  version: string
}

const getConfig = makeGet<Config>()

const toHeaders = applySpec<Record<string, string>>({
  'X-Application-Version': getConfig('version'),
  'Accept-Language': getConfig('lang'),
  'X-Requested-Uri': flow(getConfig('getURI'), f => f()),
  'Cache-Control': constant('no-cache'),
  Pragma: constant('no-cache'),
  Expires: constant('-1'),
})

function createCorpHeadersMiddleware(config: Config) {
  function _withCorpHeaders<TReq = unknown, TRes = unknown, TBody = unknown>(
    fetchFn: Fetch<TReq, TRes, TBody>,
  ): Fetch<TReq, TRes, TBody> {
    return requestConfig => fetchFn(addSafeHeaders(requestConfig, toHeaders(config)))
  }

  return _withCorpHeaders
}

export default createCorpHeadersMiddleware
